export default "__VITE_ASSET__Gv1EY877__"